/**
 * Keys used in i18n to get the translated version of the given word,
 * we use an array to give priority to the mapped entities translations
 * and falling back to the default app translations.
 */
export const TranslationKeys = {
  dataProduct_one: ['mappedEntities:dataProduct_one', 'app:dataProduct_one'],
  dataProduct_other: [
    'mappedEntities:dataProduct_other',
    'app:dataProduct_other',
  ],

  dataVendor_one: ['mappedEntities:dataVendor_one', 'app:dataVendor_one'],
  dataVendor_other: ['mappedEntities:dataVendor_other', 'app:dataVendor_other'],

  dataProvider_one: ['mappedEntities:dataVendor_one', 'app:dataProvider_one'],
  dataProvider_other: [
    'mappedEntities:dataVendor_other',
    'app:dataProvider_other',
  ],

  contact_one: ['mappedEntities:contact_one', 'app:contact_one'],
  contact_other: ['mappedEntities:contact_other', 'app:contact_other'],

  company_one: ['mappedEntities:dataVendor_one', 'app:company_one'],
  company_other: ['mappedEntities:dataVendor_other', 'app:company_other'],

  provider_one: ['mappedEntities:dataVendor_one', 'app:provider_one'],
  provider_other: ['mappedEntities:dataVendor_other', 'app:provider_other'],

  data_one: ['mappedEntities:dataProduct_one', 'app:data_one'],
  data_other: ['mappedEntities:dataProduct_other', 'app:data_other'],
};
